/* Copyright (c) 2020-present CloudIO Inc */

import React from 'react';
import classNames from 'clsx';

export interface Props {
  active?: boolean;
  white?: boolean;
  className?: string;
  fill?: boolean;
  style?: React.CSSProperties;
  reason?: string;
}

const WaveDots = (props: Props) => {
  const { active, white, fill, className, style, reason } = props;
  const cn = classNames('wave', className, {
    active,
    white,
    fill,
  });

  return (
    <span className={cn} style={style}>
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
      <span className="reason">{reason}</span>
    </span>
  );
};

export default WaveDots;
